import type { QueryClient } from '@tanstack/react-query';
import type { ProjectListRollbackContext } from '@/lib/projectListQueryCache';
import { restoreProjectListRollback } from '@/lib/projectListQueryCache';
import { markProjectsTableTrustStale } from '@/lib/projectsTableSyncPolicy';
import { reconcileProjectsTableFromServer } from '@/lib/projectsTableReconcile';

export async function rollbackProjectsAndReconcile(
  queryClient: QueryClient,
  rollback?: ProjectListRollbackContext
): Promise<void> {
  if (rollback) {
    restoreProjectListRollback(queryClient, rollback);
  }
  markProjectsTableTrustStale(queryClient);
  await reconcileProjectsTableFromServer(queryClient, { reason: 'mutation-error' });
}
